export const daysToMilliseconds = (days: number) => {
    return days * 24 * 60 * 60 * 1000;
};
